import Swal from 'sweetalert2';
import FormSimulate from './form_simulate';
import AjaxLoader from "../utilities/ajax-loader";
import RailsResource from '../services/rails-resource';

export default class ButtonConfirmation {
  constructor() {
    this.railsResource = new RailsResource({
      url: '/admin',
      ajaxLoader: true
    });

    let mutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          document.querySelectorAll('[data-swal]').forEach((el) => el.dataset.turbo = false);
        }
      });
    });
    mutation.observe(document, { subtree: true, childList: true });

    $(document).on('click', '[data-swal]', (ev) => {
      ev.preventDefault();
      ev.stopImmediatePropagation()
      ev.stopPropagation();
      let $button = ev.currentTarget,
        commonOptions = {
          showClass: {
            backdrop: 'swal2-noanimation', // disable backdrop animation
            popup: '',                     // disable popup animation
          },
          hideClass: {
            popup: '',                     // disable popup fade-out animation
          },
          customClass: {
            cancelButton: 'btn btn-gray-primary mx-2',
            confirmButton: 'btn btn-primary mx-2'
          },
          buttonsStyling: false,
          html: $button.dataset.text,
          title: ($button.dataset.title || ''),
          icon: $button.dataset.swal,
          showConfirmButton: $button.dataset.showConfirmButton === 'false' ? false : true,
          showCancelButton: $button.dataset.showCancelButton === 'false' ? false : true,
          confirmButtonText: $button.dataset.confirmButtonText || 'Sim',
          cancelButtonText: $button.dataset.cancelButtonText || 'Não'
        };

      if (!!$button.dataset.textareaName)
        return this.inputTypes($button, commonOptions)

      Swal.fire(commonOptions).then((result) => {
        if (!result.value)
          return;

        if (!!$button.dataset.inputsTargets)
          return this.inputsTargets($button)

        if ($button.dataset.remote === 'true')
          return this.sendRemotly($button);

        if (!!$button.dataset.formTarget)
          return document.querySelector($button.dataset.formTarget).submit();

        !!$button.dataset.showLoader && $button.dataset.showLoader === 'false' && AjaxLoader.show();
        (!$button.dataset.alert || $button.dataset.alert === 'false') && ButtonConfirmation.submit($button);
      });
    });
  }

  async sendRemotly($button) {
    await this.railsResource.post($button.getAttribute('href') || $button.dataset.url, true);
    Swal.fire('Pronto', `${$button.dataset.successMessage || 'Ação realizada com sucesso!'}`, 'success');
  }

  async inputsTargets($button) {
    $button.dataset.showLoader && AjaxLoader.show();
    ButtonConfirmation.submit($button, [...document.querySelectorAll($button.dataset.inputsTargets)]);
  }

  async inputTypes($button, options) {
    const result = await Swal.fire(
      Object.assign({
        input: 'textarea',
        inputLabel: $button.dataset.textareaLabel,
        inputPlaceholder: `${$button.dataset.textareaLabel}...`,
        inputAttributes: { 'aria-label': $button.dataset.textareaLabel },
      }, options));

    if (!result.isConfirmed)
      return;

    if (!$button.dataset.textareaRequired || ($button.dataset.textareaRequired == $button.dataset.textareaName && !!result.value)) {
      $button.dataset.showLoader && AjaxLoader.show();
      ButtonConfirmation.submit($button, `<input type="hidden" name="${$button.dataset.textareaName}" value="${result.value}" />`);
    } else {
      Swal.fire('Atenção', `${$button.dataset.textareaLabel} obrigatório`, 'warning');
    }
  }

  static submit($button, inputs) {
    let frameElements = undefined,
      modal = $button.closest('.modal'),
      turbo = (!!$button.dataset.updateTurbo && $button.dataset.updateTurbo === 'true' ? true : false),
      turboStream = (!!$button.dataset.updateTurboStream && $button.dataset.updateTurboStream === 'true' ? true : false),
      formTurboFrame = !!$button.hasAttribute('data-submit-like-turbo-frame') ? $button.dataset.turboFrame : undefined;
    switch ($button.dataset.turboFrame) {
      case '_self':
        frameElements = $button.closest('turbo-frame');
        turbo = true;
        break;
      case '_top':
        frameElements = 'body';
        turbo = false;
        break;
      default:
        frameElements = document.querySelector($button.dataset.turboFrame);
        break
    }

    if (!!modal && $button.dataset.closeModal === 'true')
      $(modal).modal('hide');

    return FormSimulate.submit({
      method: ($button.dataset.method || 'delete'),
      action: ($button.getAttribute('href') || $button.dataset.href),
      inputs: inputs,
      appendTo: frameElements,
      turbo: turbo,
      target: undefined,
      turboStream: turboStream,
      turboFrame: formTurboFrame
    });
  }

  static init() {
    return new ButtonConfirmation();
  }
}